import React from 'react'
import './App.less';
import AppContext from './AppContext';
import UserContext from './UserContext';
import App from './App'
import LoadingFullScreen from './components/loading/LoadingFullScreen'
//hooks
import { useLanguage } from './Utils/Hooks/useLanguage'
import { useTranslation } from 'react-i18next';
// languages for components
import { ConfigProvider } from 'antd'


export default function AppPreparations() {

  const [currentLanguage] = useLanguage();
  const { t } = useTranslation('utils')

  if(currentLanguage === undefined) {
    return (
      <LoadingFullScreen text={t("utils:retrievingData")} />
    )
  }

  return (
    <ConfigProvider locale={currentLanguage.antd}>
      <AppContext >
        <UserContext >
          <App />
        </UserContext>
      </AppContext>
    </ConfigProvider>
    )
}
